import React from 'react';

import Divider from 'elements/Divider/Divider';
import { dividersSet } from './constants';

import { ShowCase, Preview, Label } from '@components/ShowCase';

const Dividers = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          dividersSet.map((group, i) => (
            <li key={`divider-showcase-${i}`}>
              <ShowCase codeTemplate={group.codeTemplate}>
                <Preview backgroundColor={group.bgColor}>
                  <Divider {...group.options} />
                </Preview>
                <Label>
                  {group.label}
                </Label>
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Dividers;



// WEBPACK FOOTER //
// ./src/containers/elements/Dividers/Dividers.js